import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import Header from "./components/Header";
import DashboardWidgets from "./components/DashboardWidgets";
import Reports from "./components/Reports";
import Settings from "./components/Settings";
import UserManagement from "./components/UserManagement";
import Transactions from "./components/Transactions";
import CustomerSupportHub from "./components/CustomerSupportHub";
import ServiceStatusDashboard from "./components/ServiceStatusDashboard";
import AnalyticsInsights from "./components/AnalyticsInsights";
import BillingCommission from "./components/BillingCommission";
import AuditLogs from "./components/AuditLogs";
import RBAC from "./components/RBAC";
import BillPaymentsHub from "./components/BillPaymentsHub";
import Invoices from "./components/Invoices";
import WalletManagement from "./components/WalletManagement";

function App() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <Router basename={process.env.PUBLIC_URL}>
      <div className="app-shell">
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        <div className="app-main">
          <Header toggleSidebar={() => setSidebarOpen((o) => !o)} />
          <main className="app-content">
            <Routes>
              <Route path="/" element={<DashboardWidgets />} />
              <Route path="/bill-payments" element={<BillPaymentsHub />} />
              <Route path="/transactions-management" element={<Transactions />} />
              <Route path="/invoices" element={<Invoices />} />
              <Route path="/wallet" element={<WalletManagement />} />
              <Route path="/customer-support" element={<CustomerSupportHub />} />
              <Route path="/service-status" element={<ServiceStatusDashboard />} />
              <Route path="/billing&commission" element={<BillingCommission />} />
              <Route path="/user-management" element={<UserManagement />} />
              <Route path="/rbac" element={<RBAC />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/analytics" element={<AnalyticsInsights />} />
              <Route path="/audit-logs" element={<AuditLogs />} />
              <Route path="/settings" element={<Settings />} />
            </Routes>
          </main>
        </div>
      </div>
    </Router>
  );
}

export default App;
